import { useMutation } from '@tanstack/react-query'

import { type IPatchShipperCompany, type IPostBankAccount } from '../../types'
import { useUpFetch } from '../../utils'

export const useUpdateBankAccount = ({ id }: { id: number }) => {
  const upFetch = useUpFetch()

  return useMutation({
    mutationFn: async (data: IPostBankAccount) =>
      upFetch(`/companies/${id}/bank-accounts`, {
        body: data,
        method: 'POST',
      }),
  })
}

export const useUpdateShipperCompany = () => {
  const upFetch = useUpFetch()

  return useMutation({
    mutationFn: async ({ id, ...data }: IPatchShipperCompany) =>
      upFetch(`/companies/shippers/${id}`, {
        body: data,
        method: 'PATCH',
      }),
  })
}
export const useDeleteBankAccount = ({ id }: { id: number }) => {
  const upFetch = useUpFetch()

  return useMutation({
    mutationFn: async (bankAccountId: number) =>
      upFetch(`/companies/${id}/bank-accounts/${bankAccountId}`, {
        method: 'DELETE',
      }),
  })
}
